// import axios from "axios";
import React, { useState } from "react";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { useAxiosContext } from "../../context/AxiosContext";
import { useFormContext } from "../../context/FormContext";
import FieldTag from "./FieldTags/FieldTag";
import { convertAiFromDataToActualData } from "../../commonFunctions/formFunc";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { toastError } from "../../utils/toastUtils";
import { AI_PROVIDER_LIST } from "../../constant/constant";

// import "../../App.css"
const FieldsGeneraterBot = ({ setIsAiModalOpen }) => {
  const [prompt, setPrompt] = useState("");
  const [allFieldsData, setAllFieldsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { axiosInstance, handleError } = useAxiosContext();
  const [renderElements, setRenderElements] = useState([]);
  const [aiModel, setAiModel] = useState("open-ai");

  const { renderFieldsData, renderFieldsArray, setRenderFieldsArray, selectedSectionData, formSectionsData } =
    useFormContext();

  const generateFields = async () => {
    if (prompt.trim().length < 3) {
      toastError("Enter more than 2 character");
      return;
    }
    try {
      setAllFieldsData([]);
      setIsLoading(true);
      const { data } = await axiosInstance.post(`/ai/form`, { prompt: prompt, ai_model: aiModel }, { timeout: 60000 });
      if (!data.fields || data.fields.length === 0) {
        toastError("Update Prompt and TRY again");
        return;
      }

      const newData = convertAiFromDataToActualData(data.fields);
      setIsLoading(false);
      setAllFieldsData(newData);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const singleFieldDeletion = (index) => {
    const newArray = allFieldsData.filter((_, i) => i !== index);
    setAllFieldsData(newArray);
  };

  const convertAllFieldsDataToRenderElements = () => {
    const lastYInRenderFieldsArray =
      renderFieldsArray.length > 0 ? renderFieldsArray[renderFieldsArray.length - 1].y : -1;

    const newRenderElements = allFieldsData.map((field, i) => {
      const element = {
        w: 12,
        h: field.type === "container" ? field.components.length + 1 : 1,
        x: 0,
        y: lastYInRenderFieldsArray + 1 + i,
        i: field.id
      };
      return element;
    });

    setRenderElements(newRenderElements);
    formSectionsData.current[selectedSectionData].desktop_layout["outer_layout"] = [
      ...formSectionsData.current[selectedSectionData].desktop_layout["outer_layout"],
      ...newRenderElements
    ];
    setRenderFieldsArray([...renderFieldsArray, ...newRenderElements]);
  };

  const importFieldsDataToRenderer = () => {
    if (allFieldsData.length === 0) {
      toastError("No Fields Available");
      return;
    }

    const fieldObjectMap = {};

    allFieldsData.forEach((field) => {
      fieldObjectMap[field.id] = field;
    });

    renderFieldsData.current = {
      ...renderFieldsData.current,
      ...fieldObjectMap
    };
    if (renderElements.length > 0 && renderElements[renderElements.length - 1].type === "button") {
      var newArray = renderElements.slice(0, renderElements.length - 1);
      setRenderElements([...newArray, ...allFieldsData, renderElements[renderElements.length - 1]]);
    } else {
      setRenderElements([...renderElements, ...allFieldsData]);
    }
    convertAllFieldsDataToRenderElements();
    setIsAiModalOpen(false);
  };

  return (
    <div className="ai_generator_model">
      <SingleSelectBox
        selectedData={aiModel}
        options={AI_PROVIDER_LIST}
        label="Select AI Model"
        onChange={(obj) => setAiModel(obj.id)}
        containerClassName={"w_fit"}
        containerStyle={{ minWidth: "150px" }}
      />

      <div className="fieldRender_bot_header">
        <div style={{ minWidth: "164px" }}>
          <Input value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="Enter Prompt" />
        </div>
        <div className="d_flex align_center gap_2">
          <Button onClick={generateFields}>Generate</Button>
          <Button variant="secondary" onClick={importFieldsDataToRenderer}>
            Import <MaterialIcon name="download" style={{ fontSize: "20px" }} />
          </Button>
        </div>{" "}
      </div>
      <div className="fieldRender_bot_fieldsOuter">
        {!isLoading && allFieldsData.length === 0 && <div className="loader">Search Your Query</div>}
        {isLoading ? (
          <div className="loader">
            <img src="/Settings.gif" alt="Book Animation" />
            <p>Wait! Something amazing is on its way...</p>
          </div>
        ) : (
          <div className="fieldRender_bot_fields">
            {allFieldsData.length > 0 &&
              allFieldsData.map((field, i) => {
                return (
                  <>
                    <div
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "14px" }}
                    >
                      <div style={{ width: "100%" }}>
                        <FieldTag key={field.id} element={field} />
                      </div>
                      <MaterialIcon
                        name="delete"
                        style={{ padding: "6px 0", color: "red", cursor: "pointer" }}
                        onClick={() => singleFieldDeletion(i)}
                      />
                    </div>
                    <br />
                  </>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default FieldsGeneraterBot;
